import React, { useEffect } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Link,
	useLocation,
	Outlet,
	useNavigate,
} from "react-router-dom";
import BottomTab from "./BottomTab";
import "../styles/LandingPage.css";
import QuestionnaireFormIntake from "./QuestionnaireFormIntake";
import { Toolbar } from "@mui/material";
import { useAuth } from "react-oidc-context";
const LandingPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const auth = useAuth();

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		if (params.has("code") && auth.isAuthenticated) {
			// Remove all parameters from the URL
			navigate(location.pathname, { replace: true });
		}
	}, [location, navigate, auth.isAuthenticated]);

	return (
		<div>
			{/* <SidebarNav /> */}
			<QuestionnaireFormIntake />
		</div>
	);
};

export default LandingPage;
